import { isNil } from 'lodash';

export function undefinedOr<T, V>(v: T | undefined | null, fn: (value: T) => V): V | undefined;
export function undefinedOr<T, V>(v: T | undefined | null, fn: (value: T) => Promise<V>): Promise<V> | undefined;
export function undefinedOr<T, V>(v: T | undefined | null, fn: (value: T) => V | Promise<V>): V | Promise<V> | undefined {
  if (isNil(v)) return undefined;
  return fn(v);
}